// types/constants/ScreenSizes.ts
export enum ScreenSize {
    MOBILE = 768,
    TABLET = 1024,
    LAPTOP = 1280,
    DESKTOP = 1440,
}
